import getDefaultAbsoluteTime from './get-default-absolute-time';
export default getDefaultAbsoluteTime;
